import React from 'react';
import PropTypes from 'prop-types';
import {SwitchInput} from "../../components/Forms";
// import { Text} from 'rebass'
import {Wrapper} from './styles'

const NotificationsPanel = props => {
	// const {handleUpdate} = props;
	return (
		<Wrapper>

			<SwitchInput
				title={'In-App'}
				description={'By switching on the switch, you will receive notifications from the Wave app, including announcements, leaves, and chats'}
				name={'notify-app'}
				/>

			<SwitchInput
				title={'Email'}
				description={'By switching on the switch, you will receive notifications via your email, including announcements, leaves, and chats'}
				name={'notify-email'}
			/>

			<SwitchInput
				title={'Text'}
				description={'By switching on the switch, you will receive notifications via text message, including announcements, leaves, and chats.'}
				name={'notify-text'}
			/>
		</Wrapper>
	);
};

NotificationsPanel.propTypes = {
	handleUpdate: PropTypes.func,
	profile: PropTypes.object
};

NotificationsPanel.defaultProps = {
	// profile: {}
};

export default NotificationsPanel;
